import { Typography } from '@mui/material'
import { useController } from '../hooks/useController'
import { useTexts } from '../hooks/useTexts'

export function Body() {
  const texts = useTexts()
  const {
    data: { depotIds },
  } = useController()

  return <Typography>{texts.body(depotIds.length)}</Typography>
}
